import clsx from "clsx";
import { useUserContext } from "components/context/UserContext";
import { useRouter } from "components/hooks";
import { formatTimeStampToDateAndTime, handleRedirectOrPopupActionForNotification } from "utils/HelperFunctions";

type Props = {
  imageUrl: string;
  title?: string;
  description?: string;
  createdAt: string;
  additionalClasses?: string;
  descriptionClasses?: string;
  createdAtClasses?: string;
  navigationLink: string | null;
  actionType: string;
  subType: string;
  iconUrl?: string | null;
  textDark?: boolean;
};

function UserAndMagnetActivityCard({
  textDark = false,
  imageUrl,
  description,
  title,
  additionalClasses,
  createdAt,
  descriptionClasses,
  createdAtClasses,
  navigationLink,
  actionType,
  subType,
  iconUrl,
}: Props) {
  const router = useRouter();

  const { reloadUserData, setCurrentlyViewingMementoId, setNotificationSubType } = useUserContext();

  const handleCardClick = () => {
    setNotificationSubType(subType);
    const isUserReloadNotification = navigationLink?.includes("reloadUser");

    if (isUserReloadNotification) {
      reloadUserData();
    }

    if (navigationLink) {
      const link = handleRedirectOrPopupActionForNotification(
        {
          action_type: actionType,
          cta: navigationLink,
          sub_type: subType,
        },
        setCurrentlyViewingMementoId,
      );
      // In some case click acitivy for a magnet, can be handled without redirect by just opening up the modal .
      if (link) router.go(link);
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div
      onClick={handleCardClick}
      className={clsx(
        "flex items-center justify-between rounded-ll  md:items-start",
        "cursor-pointer border-secondary p-1.5 md:p-3 2xl:p-4",
        textDark ? "text-primary" : "text-white",
        additionalClasses,
      )}
    >
      <div className="flex cursor-pointer items-start">
        <img
          className="mr-2 aspect-1 w-14 rounded-lg 
           
           object-cover 2xl:mr-4 2xl:w-16"
          src={imageUrl}
          alt={title}
        />
        <div className="my-auto">
          {title && (
            <p
              className="line-clamp-3 break-normal font-satoshi text-xxs font-semibold leading-5 xl:mb-0
         2xl:mb-1 2xl:text-xs"
            >
              {title}
            </p>
          )}
          {/* Html will be recieved for the heading */}
          {description && (
            <p
              className={clsx(
                "break-normal font-satoshi text-xxs font-450 leading-4 lg:text-xs lg:leading-5 xl:mb-0 2xl:mb-1 2xl:text-sm",
                descriptionClasses,
              )}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          <div className={clsx("font-satoshi text-xxs font-450 leading-5 opacity-50 2xl:text-xxs", createdAtClasses)}>
            {formatTimeStampToDateAndTime(createdAt)}
          </div>
        </div>
      </div>
      {iconUrl && (
        <img
          className="aspect-1 w-6 object-cover md:ml-4 md:mt-3 xl:h-6 xl:w-6 2xl:mt-5 2xl:w-7"
          src={iconUrl}
          alt={`${title}-icon`}
        />
      )}
    </div>
  );
}
export default UserAndMagnetActivityCard;

// UserAndMagnetActivityCard.defaultProps = {
//   imageUrl: "https://magnetiq-static.s3.amazonaws.com/media/public/logo_ldyZXyn.png",
//   title: "Test Notifcaton Tile",
//   description: "Descriptino",
//   createdAt: new Date().toISOString(),
// };
